import axios from '@/jslib/axios'

export const getCarClassIndex = (params) => {
  return axios({
    method: 'get',
    url: '/admin/car/class/index',
    params
  })
}
export const getCarClassOption = (params) => {
  return axios({
    method: 'get',
    url: '/admin/car/class/option',
    params
  })
}

export const getCarClassInit = (params) => {
  return axios({
    method: 'get',
    url: '/admin/car/model/class/init',
    params,
    timeout: 600000
  })
}
//manage class
export const getCarClassList = (params) => {
  return axios({
    method: 'get',
    url: '/admin/car/class/list',
    params
  })
}
export const updateCarClass = data => {
  return axios({
    method: 'post',
    url: '/admin/car/class/update',
    data
  })
}
//class list
export const getCarModelClassList = (params) => {
  return axios({
    method: 'get',
    url: '/admin/car/model/class/list',
    params
  })
}
export const updateCarModelClassList = (data) => {
  return axios({
    method: 'post',
    url: '/admin/car/model/class/update',
    data
  })
}
//make
export const getCarMakeList = params => {
  return axios({
    method: 'get',
    url: '/admin/car/make/list',
    params
  })
}
export const addCarMake = data => {
  return axios({
    method: 'post',
    url: '/admin/car/make/add',
    data
  })
}
export const updateCarMake = data => {
  return axios({
    method: 'post',
    url: '/admin/car/make/update',
    data
  })
}
export const updateSingleCarMake = data => {
  return axios({
    method: 'post',
    url: '/admin/car/make/single/update',
    data
  })
}
//model
export const getCarModelList = params => {
  return axios({
    method: 'get',
    url: '/admin/car/model/list',
    params
  })
}

export const addCarModel = data => {
  return axios({
    method: 'post',
    url: '/admin/car/model/add',
    data
  })
}
export const updateCarModel = data => {
  return axios({
    method: 'post',
    url: '/admin/car/model/update',
    data
  })
}
export const clearCarClass = (data) => {
  return axios({
    method: 'post',
    url: '/admin/cache/clear',
    data,
  })
}
